<template>
    <el-drawer :modal="false" 
        title="Edit Profile"
        :visible.sync="drawerEditProfile"
        class="drawer-edit-profile"
        size="45%"
    >
        <b-container>
						<el-collapse accordion>
                <el-collapse-item name="1" class="my-3">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">General</h3>
                    </div>
                    <general-form :customer.sync="current_customer" :tables="tables"></general-form>
                </el-collapse-item>
                <el-collapse-item name="2" class="my-3">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Bank Details</h3>
                    </div>
                    <bank-details-form :customer.sync="current_customer" :tables="tables"></bank-details-form>
                </el-collapse-item>
                <el-collapse-item name="3" class="my-3">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Company Information</h3>
                    </div>
                    <company-info-form :customer.sync="current_customer" :tables="tables"></company-info-form>
                </el-collapse-item>
                <el-collapse-item name="4" class="my-3">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Spouse Information</h3>
                    </div>
                    <spouse-info-form :customer.sync="current_customer"></spouse-info-form>
                </el-collapse-item>
                <el-collapse-item name="5" class="my-3">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Emergency Contact Information</h3>
                    </div>
                    <emergency-info-form :customer.sync="current_customer" :tables="tables"></emergency-info-form>
                </el-collapse-item>
            </el-collapse>
        </b-container>
    </el-drawer>
</template>
<script>
    import { Button, Drawer, Collapse, CollapseItem } from 'element-ui'
    import GeneralForm from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerEditProfile/GeneralForm'
    import BankDetailsForm from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerEditProfile/BankDetailsForm'
    import CompanyInfoForm from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerEditProfile/CompanyInfoForm'
    import SpouseInfoForm from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerEditProfile/SpouseInfoForm'
    import EmergencyInfoForm from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerEditProfile/EmergencyInfoForm'
    import { mapActions, mapState } from 'pinia'
    import { useCustomerStore } from '@/stores/customerStore'
    import { useLookupStore } from '@/stores/lookupStore'

    export default {
        name: 'drawer-edit-profile',
        components: {
            GeneralForm,
            BankDetailsForm,
            CompanyInfoForm,
            SpouseInfoForm,
            EmergencyInfoForm,
            [Button.name]: Button,
            [Drawer.name]: Drawer,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
        },
        data() {
            return {
                drawerEditProfile: false,
                tables: [],
            };
        },
        computed: {
            ...mapState(useCustomerStore,['current_customer'])
        },
        watch:{
            async drawerEditProfile(newVal){
                if(newVal === true && this.tables.length === 0){
                    this.tables = await this.getLookupTables([
                        'countries',
                        'states',
                        'educations', 
                        'nationalities',
                        'banks',
                        'business_natures', 
                        'business_departments', 
                        'employment_types'
                    ])
                }
            }
        },
        methods: {
						...mapActions(useLookupStore,['getLookupTables']),
            viewEditProfile() {
                this.drawerEditProfile = !this.drawerEditProfile;
            }
        }
    }
</script>